import { concat } from '../../helpers/common'

import { targetingTypes } from '../../forms/DV360/LineItemForms/LineItemDv360Create/fields'

const MODULE_NAME = 'DV360_CONSTANTS/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION

// targeting
export const GET_DV360_TARGETING = concat(MODULE_NAME, 'GET_DV360_TARGETING')
export const GET_DV360_TARGETING_SUCCESS = concat(MODULE_NAME, 'GET_DV360_TARGETING_SUCCESS')
export const GET_DV360_TARGETING_FAILURE = concat(MODULE_NAME, 'GET_DV360_TARGETING_FAILURE')
export const CLEAR_DV360_TARGETING = concat(MODULE_NAME, 'CLEAR_DV360_TARGETING')

// search targeting options
export const SEARCH_DV360_TARGETING_OPTIONS = concat(MODULE_NAME, 'SEARCH_DV360_TARGETING_OPTIONS')
export const SEARCH_DV360_TARGETING_OPTIONS_SUCCESS = concat(MODULE_NAME, 'SEARCH_DV360_TARGETING_OPTIONS_SUCCESS')
export const SEARCH_DV360_TARGETING_OPTIONS_FAILURE = concat(MODULE_NAME, 'SEARCH_DV360_TARGETING_OPTIONS_FAILURE')
export const CLEAR_SEARCH_DV360_TARGETING_OPTIONS = concat(MODULE_NAME, 'CLEAR_SEARCH_DV360_TARGETING_OPTIONS')

// update bulk targeting
export const UPDATE_DV360_BULK_TARGETING = concat(MODULE_NAME, 'UPDATE_DV360_BULK_TARGETING')
export const UPDATE_DV360_BULK_TARGETING_SUCCESS = concat(MODULE_NAME, 'UPDATE_DV360_BULK_TARGETING_SUCCESS')
export const UPDATE_DV360_BULK_TARGETING_FAILURE = concat(MODULE_NAME, 'UPDATE_DV360_BULK_TARGETING_FAILURE')
export const CLEAR_UPDATE_DV360_BULK_TARGETING = concat(MODULE_NAME, 'CLEAR_UPDATE_DV360_BULK_TARGETING')

export const GET_DV360_TARGETING_OPTIONS = concat(MODULE_NAME, 'GET_DV360_TARGETING_OPTIONS')
export const GET_DV360_TARGETING_OPTIONS_SUCCESS = concat(MODULE_NAME, 'GET_DV360_TARGETING_OPTIONS_SUCCESS')
export const GET_DV360_TARGETING_OPTIONS_FAILURE = concat(MODULE_NAME, 'GET_DV360_TARGETING_OPTIONS_FAILURE')
export const CLEAR_GET_DV360_TARGETING_OPTIONS = concat(MODULE_NAME, 'CLEAR_GET_DV360_TARGETING_OPTIONS')

export const GET_DV360_VIEWABILITY_TARGETING_OPTIONS = concat(MODULE_NAME, 'GET_DV360_VIEWABILITY_TARGETING_OPTIONS')
export const GET_DV360_VIEWABILITY_TARGETING_OPTIONS_SUCCESS = concat(
  MODULE_NAME,
  'GET_DV360_VIEWABILITY_TARGETING_OPTIONS_SUCCESS'
)
export const GET_DV360_VIEWABILITY_TARGETING_OPTIONS_FAILURE = concat(
  MODULE_NAME,
  'GET_DV360_VIEWABILITY_TARGETING_OPTIONS_FAILURE'
)
export const CLEAR_GET_DV360_VIEWABILITY_TARGETING_OPTIONS = concat(
  MODULE_NAME,
  'CLEAR_GET_DV360_VIEWABILITY_TARGETING_OPTIONS'
)

export const GET_DV360_EXCHANGE_TARGETING_OPTIONS = concat(MODULE_NAME, 'GET_DV360_EXCHANGE_TARGETING_OPTIONS')
export const GET_DV360_EXCHANGE_TARGETING_OPTIONS_SUCCESS = concat(
  MODULE_NAME,
  'GET_DV360_EXCHANGE_TARGETING_OPTIONS_SUCCESS'
)
export const GET_DV360_EXCHANGE_TARGETING_OPTIONS_FAILURE = concat(
  MODULE_NAME,
  'GET_DV360_EXCHANGE_TARGETING_OPTIONS_FAILURE'
)
export const CLEAR_GET_DV360_EXCHANGE_TARGETING_OPTIONS = concat(
  MODULE_NAME,
  'CLEAR_GET_DV360_EXCHANGE_TARGETING_OPTIONS'
)

export const GET_DV360_CHANNELS = concat(MODULE_NAME, 'GET_DV360_CHANNELS')
export const GET_DV360_CHANNELS_SUCCESS = concat(MODULE_NAME, 'GET_DV360_CHANNELS_SUCCESS')
export const GET_DV360_CHANNELS_FAILURE = concat(MODULE_NAME, 'GET_DV360_CHANNELS_FAILURE')
export const CLEAR_GET_DV360_CHANNELS = concat(MODULE_NAME, 'CLEAR_GET_DV360_CHANNELS')

export const GET_DV360_NEGATIVE_KEYWORD_LISTS = concat(MODULE_NAME, 'GET_DV360_NEGATIVE_KEYWORD_LISTS')
export const GET_DV360_NEGATIVE_KEYWORD_LISTS_SUCCESS = concat(MODULE_NAME, 'GET_DV360_NEGATIVE_KEYWORD_LISTS_SUCCESS')
export const GET_DV360_NEGATIVE_KEYWORD_LISTS_FAILURE = concat(MODULE_NAME, 'GET_DV360_NEGATIVE_KEYWORD_LISTS_FAILURE')
export const CLEAR_GET_DV360_NEGATIVE_KEYWORD_LISTS = concat(MODULE_NAME, 'CLEAR_GET_DV360_NEGATIVE_KEYWORD_LISTS')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// Get targeting
export function getDv360Targeting(params) {
  return { type: GET_DV360_TARGETING, params }
}

export function getDv360TargetingSuccess(data) {
  return { type: GET_DV360_TARGETING_SUCCESS, data }
}

export function getDv360TargetingFailure(error) {
  return { type: GET_DV360_TARGETING_FAILURE, error }
}

export function clearDv360Targeting() {
  return { type: CLEAR_DV360_TARGETING }
}

// Search targeting options
export function searchDv360TargetingOptions(params) {
  return { type: SEARCH_DV360_TARGETING_OPTIONS, params }
}

export function searchDv360TargetingOptionsSuccess(data) {
  return { type: SEARCH_DV360_TARGETING_OPTIONS_SUCCESS, data }
}

export function searchDv360TargetingOptionsFailure(error) {
  return { type: SEARCH_DV360_TARGETING_OPTIONS_FAILURE, error }
}

export function clearSearchTargetingOptions() {
  return { type: CLEAR_SEARCH_DV360_TARGETING_OPTIONS }
}

// Update bulk targeting
export function updateDv360BulkTargeting(targetingData, shouldReFetchLineItemTargeting = false) {
  return { type: UPDATE_DV360_BULK_TARGETING, targetingData, shouldReFetchLineItemTargeting }
}

export function updateDv360BulkTargetingSuccess(data) {
  return { type: UPDATE_DV360_BULK_TARGETING_SUCCESS, data }
}

export function updateDv360BulkTargetingFailure(error) {
  return { type: UPDATE_DV360_BULK_TARGETING_FAILURE, error }
}

export function clearUpdateDv360BulkTargeting() {
  return { type: CLEAR_UPDATE_DV360_BULK_TARGETING }
}

// Get dv360 targeting options
export function getDv360TargetingOptions(params) {
  return { type: GET_DV360_TARGETING_OPTIONS, params }
}

export function getDv360TargetingOptionsSuccess(data) {
  return { type: GET_DV360_TARGETING_OPTIONS_SUCCESS, data }
}

export function getDv360TargetingOptionsFailure(error) {
  return { type: GET_DV360_TARGETING_OPTIONS_FAILURE, error }
}

export function clearGetDv360TargetingOptions() {
  return { type: CLEAR_GET_DV360_TARGETING_OPTIONS }
}

// Get dv360 exchange targeting options
export function getDv360ExchangeTargetingOptions(params) {
  return {
    type: GET_DV360_EXCHANGE_TARGETING_OPTIONS,
    params: {
      // getDv360ExchangeTargetingOptions uses the same endpoint as getDv360TargetingOptions, but with hardcoded targeting_type
      targeting_type: targetingTypes.TARGETING_TYPE_EXCHANGE,
      ...params
    }
  }
}

export function getDv360ExchangeTargetingOptionsSuccess(data) {
  return { type: GET_DV360_EXCHANGE_TARGETING_OPTIONS_SUCCESS, data }
}

export function getDv360ExchangeTargetingOptionsFailure(error) {
  return { type: GET_DV360_EXCHANGE_TARGETING_OPTIONS_FAILURE, error }
}

export function clearGetDv360ExchangeTargetingOptions() {
  return { type: CLEAR_GET_DV360_EXCHANGE_TARGETING_OPTIONS }
}

// Get dv360 viewability targeting options
export function getDv360ViewabilityTargetingOptions(params) {
  return {
    type: GET_DV360_VIEWABILITY_TARGETING_OPTIONS,
    params: {
      // getDv360ViewabilityTargetingOptions uses the same endpoint as getDv360TargetingOptions, but with hardcoded targeting_type
      targeting_type: targetingTypes.TARGETING_TYPE_VIEWABILITY,
      ...params
    }
  }
}

export function getDv360ViewabilityTargetingOptionsSuccess(data) {
  return { type: GET_DV360_VIEWABILITY_TARGETING_OPTIONS_SUCCESS, data }
}

export function getDv360ViewabilityTargetingOptionsFailure(error) {
  return { type: GET_DV360_VIEWABILITY_TARGETING_OPTIONS_FAILURE, error }
}

export function clearGetDv360ViewabilityTargetingOptions() {
  return { type: CLEAR_GET_DV360_VIEWABILITY_TARGETING_OPTIONS }
}

// Get dv360 channels
export function getDv360Channels(params) {
  return { type: GET_DV360_CHANNELS, params }
}

export function getDv360ChannelsSuccess(data) {
  return { type: GET_DV360_CHANNELS_SUCCESS, data }
}

export function getDv360ChannelsFailure(error) {
  return { type: GET_DV360_CHANNELS_FAILURE, error }
}

export function clearGetDv360Channels() {
  return { type: CLEAR_GET_DV360_CHANNELS }
}

// Get dv360 negative keyword lists
export function getDv360NegativeKeywordLists(params) {
  return { type: GET_DV360_NEGATIVE_KEYWORD_LISTS, params }
}

export function getDv360NegativeKeywordListsSuccess(data) {
  return { type: GET_DV360_NEGATIVE_KEYWORD_LISTS_SUCCESS, data }
}

export function getDv360NegativeKeywordListsFailure(error) {
  return { type: GET_DV360_NEGATIVE_KEYWORD_LISTS_FAILURE, error }
}

export function clearGetDv360NegativeKeywordLists() {
  return { type: CLEAR_GET_DV360_NEGATIVE_KEYWORD_LISTS }
}
